import { X } from "lucide-react";
import { HelperLinks } from "@/components/playbook/MomentHelpers";

// Shown after a hard check-in: the member's own top helpers for this kind of moment
export const PlaybookToast = ({ helpers, onClose }) => (
  <div className="w-[min(92vw,380px)] rounded-3xl bg-[#F3EEFC] p-4 shadow-xl border border-mm-primary/15" data-testid="playbook-toast">
    <div className="flex items-start justify-between gap-3">
      <div><div className="font-semibold text-[#3A2E4F]">🌱 Your playbook says these help you</div><div className="text-xs text-mm-muted">From your own check-ins and tools</div></div>
      <button onClick={onClose} className="text-mm-muted p-1" aria-label="Close" data-testid="playbook-toast-close"><X size={16} /></button>
    </div>
    <div className="mt-3"><HelperLinks helpers={helpers} onPick={onClose} /></div>
  </div>
);
